import API from "../../../api/axiosClient";
import { UpdateUserDto, UpdateUserPermissionDto, UserDto, UserStatisticsDto } from "../types/User";


const url = "Users";

const UserService = {

    getAll: async (): Promise<UserDto[]> => {
        const response = await API.get(url);
        return response.data;
    },

    getById: async (userId: string): Promise<UserDto> => {
        const response = await API.get(`${url}/${userId}`);
        return response.data;
    },

    update: async (userId: string, data: UpdateUserDto): Promise<void> => {

        await API.put(`${url}/${userId}`, data);

    },

    updatePermissions: async (userId: string, data: UpdateUserPermissionDto): Promise<void> => {

        await API.put(`${url}/${userId}/permissions`, data);

    },

    delete: async (userId: string): Promise<void> => {
        await API.delete(`${url}/${userId}`);

    },

    getUserStatistics: async () => {
        const response = await API.get<UserStatisticsDto>("Users/statistics");

        return response.data;
    }

};

export default UserService;